export default {"src":"/_next/static/media/company-4.7cfed14a.svg","height":71,"width":223};